import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import {
  sharedActions,
} from './store/actions';

import { TaxBookingEntityPropTypes } from '../../shared/propTypes/taxBookingEntities';
import getPermissionsFromTree from '../../shared/authorization/getPermissionsFromTree.helper';
import permissionPaths from '../../shared/authorization/permissionPaths';
import permissionTypes from '../../shared/authorization/permissionTypes';
import { UserPropTypes } from '../../shared/propTypes/users';
import { userSelector } from '../../shared/store/selectors';

class TaxBookingEntitiesAdminColumnRenderer extends PureComponent {
  static propTypes = {
    value: TaxBookingEntityPropTypes,
    showTaxBookingEntitiesModalForEdit: PropTypes.func.isRequired,
    showTaxBookingEntitiesModalForDelete: PropTypes.func.isRequired,
    rowIndex: PropTypes.number.isRequired,
    user: UserPropTypes,
  };

  showTaxBookingEntitiesModalForEdit = () => {
    const { value, showTaxBookingEntitiesModalForEdit } = this.props;
    showTaxBookingEntitiesModalForEdit(value);
  };

  showTaxBookingEntitiesModalForDelete = () => {
    const { value, rowIndex, showTaxBookingEntitiesModalForDelete } = this.props;
    showTaxBookingEntitiesModalForDelete({ entity: value, rowIndex });
  };

  render() {
    const { user } = this.props;

    const canUserDeletePermission = getPermissionsFromTree(
      user.permissions, permissionPaths.TAX_BOOKING_ENTITIES
    )[permissionTypes.DELETE];

    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit Tax Booking Entity"
          onClick={this.showTaxBookingEntitiesModalForEdit}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>
        {
          canUserDeletePermission
            && (
              <button
                className="cell-icon-button"
                title="Delete Tax Booking Entity"
                onClick={this.showTaxBookingEntitiesModalForDelete}
              >
                <TrashIcon size={16} className="cell-icon"/>
              </button>
            )
        }
      </div>
    );
  }
}

export default connect(
  state => ({
    user: userSelector(state),
  }),
  {
    showTaxBookingEntitiesModalForEdit: sharedActions.showModalForAddEdit,
    showTaxBookingEntitiesModalForDelete: sharedActions.showModalForRemove,
  }
)(TaxBookingEntitiesAdminColumnRenderer);
